import { sdkFactory as wixBookingsStaffV1StaffMember_sdkFactory_staffMembers } from './src/bookings-staff-v1-staff-member.frontend';
import { sdkFactory as wixBookingsCatalogV1Resource_sdkFactory_resources } from './src/bookings-catalog-v1-resource.frontend';
import { sdkFactory as wixBookingsV1Category_sdkFactory_categories } from './src/bookings-v1-category.frontend';
export function sdkFactory(args) {
    return {
        staffMembers: wixBookingsStaffV1StaffMember_sdkFactory_staffMembers(args),
        resources: wixBookingsCatalogV1Resource_sdkFactory_resources(args),
        categories: wixBookingsV1Category_sdkFactory_categories(args),
    };
}
//# sourceMappingURL=index.frontend.js.map